import { render, staticRenderFns } from "./GeographyTeacher.vue?vue&type=template&id=9028e7d8&scoped=true&lang=pug&"
import script from "./GeographyTeacher.vue?vue&type=script&lang=js&"
export * from "./GeographyTeacher.vue?vue&type=script&lang=js&"
import style0 from "./GeographyTeacher.vue?vue&type=style&index=0&id=9028e7d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9028e7d8",
  null
  
)

export default component.exports